import NavBar from './NavBar.vue';
import withInstall from '@/shared/withInstall';

export const XNavBar = withInstall(NavBar);
export default XNavBar;
